import { createFileRoute } from '@tanstack/react-router'

import { RequireMember } from '@/features/identity/RequireMember'

export const Route = createFileRoute('/app')({
  component: RequireMember,
})
